import React from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";

const TimesheetHeader = ({ dates, auth }) => (
  <Row className="time-header">
    <Col
      md={6}
      className={`details ${auth.isNightMode ? "is-night-mode" : ""}`}
    >
      <span>Customer</span>
      <span>Project</span>
      <span>Service</span>
    </Col>
    <Col className="days" md={6}>
      {dates.map((date, i) => (
        <span key={i}>
          <p>{date.day}</p>
          {date.display}
        </span>
      ))}
      <span>Total</span>
    </Col>
  </Row>
);
TimesheetHeader.propTypes = {
  dates: PropTypes.array,
  auth: PropTypes.object
};

export default TimesheetHeader;
